import React, { Component } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { getPreAdmissionStatusFromId } from '@autofact-lib/operation-lib-model-notary-platform';
import PropTypes from 'prop-types';
import { formats } from '../../config';
import DataTable from '../data-table/DataTable';

class PreAdmissionList extends Component {
  constructor(props) {
    super(props);
    this.dataTableRef = React.createRef();
  }

  reloadData() {
    this.dataTableRef.current.reloadData();
  }

  render() {
    const columns = [
      {
        Header: 'Número de preingreso',
        accessor: 'codigo_preingreso',
      },
      {
        Header: 'Patente',
        accessor: 'patente',
      },
      {
        Header: 'Fecha de creación',
        accessor: 'created_at',
        Cell: (row) => {
          const date = moment(row.original.created_at);
          return date.format(formats.date);
        },
      },
      {
        Header: 'Número de repertorio',
        accessor: 'documento_numero',
      },
      {
        Header: 'Ver',
        width: 60,
        accesor: 'idpreingreso',
        Cell: (row) => (
          <span key={`detail-link-span-${row.original.idpreingreso}`}>
            <Link
              key={`detail-link-${row.original.idpreingreso}`}
              className="btn btn-primary-darker btn-sm btn-see-link"
              to={`preingreso/ver/${row.original.idpreingreso}`}
            >
              VER
            </Link>
          </span>
        ),
      },
      {
        Header: 'Estado',
        accesor: 'estado',
        width: 160,
        Cell: (row) =>
        // TODO check the user status, some users can't see some status
          (
            <span key={`status-${row.original.idtransferencia}`} className={`pre-admission-status pre-admission-status-sm pre-admission-status-${row.original.estado}`}>
              {getPreAdmissionStatusFromId(row.original.estado).label}
            </span>
          ),

      },
    ];
    return (
      <div className="pre-admission-list-wrapper">
        <DataTable
          ref={this.dataTableRef}
          key={`data-table-${this.props.id}`}
          id={this.props.id}
          columns={columns}
          {...this.props}
        />
      </div>
    );
  }
}

PreAdmissionList.propTypes = {
  id: PropTypes.string,
};

export default PreAdmissionList;
